export { default as FlashSaleTimerHeader } from './FlashSaleTimerHeader';
export { default as ExpiredText } from './ExpiredText';
export { default as ClockCountdown } from './ClockCountdown';
export * as Styled from './FlashSaleTimerHeader.styles';
export * from './FlashSaleTimerHeader.types';
